exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9a9cf9ec] .el-card__body{height:100%}[data-v-9a9cf9ec] .el-tabs{height:calc(100% - 70px)}[data-v-9a9cf9ec] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}[data-v-9a9cf9ec] .el-tab-pane{height:100%}[data-v-9a9cf9ec] .el-form-item__label{text-align:right}[data-v-9a9cf9ec] .el-upload{width:100%}", ""]);

// exports
